module.exports = __webpack_public_path__ + "static/media/logo-animado.df4b177f.mp4";